import React, { PropTypes } from 'react'
import ToggleMenu from '../../components/layout/actions/ToggleMenu.jsx'
import DeviceDetect from '../../components/layout/tools/DeviceDetect'

import { connect } from 'react-redux'

import { showModal, hideModal } from '../../actions/ModalAction'
import { MODEL_TYPE_CONFIRM } from '../modal/ModalRoot'
import { logout } from '../../actions/LoginAction'

const Header = ({onLogout}) => (
    <header id="header">
            <div id="logo-group">
                <span id="logo">
                    <img src="/styles/img/logo.png" // place your logo here
                         alt="ShopCollect Admin"/>
                </span>
            </div>

            <div className="pull-right"  /*pulled right: nav area*/ >

                <ToggleMenu className="btn-header pull-right"   collapse menu button  />

                {/* logout button */}
                <div id="logout" className="btn-header transparent pull-right" >
                    <span > <a href="#" onClick={() => onLogout()} ><i
                        className="fa fa-sign-out"/></a> </span>
                </div>


            </div>

            <DeviceDetect />

        </header>
)

Header.propTypes = {
  onLogout: PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => {
      dispatch(
        showModal(MODEL_TYPE_CONFIRM, {
          body:'ログアウトしますか',
          onConfirm: ()=>{
            dispatch(hideModal())
            dispatch(logout())
          },
          onCancel: ()=>{
            dispatch(hideModal())
          }
        }))
    }
  }
}

export default connect(null, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/pages/layout/Header.js